/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Assign_SubmitInputs */

const vi_cdo_assign_submit = /** @type {(inputs: Cdo_Assign_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gán`)
};

/**

* @param {Cdo_Assign_SubmitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_assign_submit = /** @type {((inputs?: Cdo_Assign_SubmitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Assign_SubmitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_assign_submit(inputs)
});